// Achievement badges + unlockable sticker rewards.
import { IMG } from "./data";

export const BADGES = [
  { id: "first-steps", title: "First Steps", emoji: "🐣", desc: "Finish your first activity", test: s => s.activitiesCompleted >= 1 },
  { id: "star-10", title: "Star Collector", emoji: "⭐", desc: "Earn 10 stars", test: s => s.stars >= 10 },
  { id: "star-50", title: "Star Hero", emoji: "🌟", desc: "Earn 50 stars", test: s => s.stars >= 50 },
  { id: "star-150", title: "Superstar", emoji: "💫", desc: "Earn 150 stars", test: s => s.stars >= 150 },
  { id: "streak-3", title: "On Fire", emoji: "🔥", desc: "3-day streak", test: s => s.streak >= 3 },
  { id: "streak-7", title: "Week Warrior", emoji: "🏅", desc: "7-day streak", test: s => s.streak >= 7 },
  { id: "daily-1", title: "Daily Champ", emoji: "🏆", desc: "Complete a Daily Adventure", test: s => (s.dailyCompletions || 0) >= 1 },
  { id: "daily-5", title: "Adventure Master", emoji: "🗺️", desc: "Complete 5 Daily Adventures", test: s => (s.dailyCompletions || 0) >= 5 },
  { id: "abc-explorer", title: "ABC Explorer", emoji: "🔤", desc: "Finish 3 ABC activities", test: s => modeCount(s, "abc") >= 3 },
  { id: "number-ninja", title: "Number Ninja", emoji: "🔢", desc: "Finish 3 Numbers activities", test: s => modeCount(s, "numbers") >= 3 },
  { id: "color-artist", title: "Color Artist", emoji: "🎨", desc: "Finish 3 Colors activities", test: s => modeCount(s, "colors") >= 3 },
  { id: "shape-wizard", title: "Shape Wizard", emoji: "🔷", desc: "Finish 3 Shapes activities", test: s => modeCount(s, "shapes") >= 3 },
  { id: "animal-friend", title: "Animal Friend", emoji: "🐾", desc: "Finish 3 Animals activities", test: s => modeCount(s, "animals") >= 3 },
  { id: "memory-master", title: "Memory Master", emoji: "🧠", desc: "Win 3 memory games", test: s => modeCount(s, "memory") >= 3 },
  { id: "tracer", title: "Little Artist", emoji: "✏️", desc: "Trace 5 letters or shapes", test: s => (s.categories.tracing?.correct || 0) >= 5 },
  { id: "all-rounder", title: "All-Rounder", emoji: "🌈", desc: "Try every learning section", test: s => ["abc", "numbers", "colors", "shapes", "animals", "fruits", "everyday", "matching", "counting", "tracing"].every(k => (s.categories[k]?.total || 0) > 0) },
];

function modeCount(s, section) {
  return Object.values(s.modesCompleted?.[section] || {}).reduce((a, b) => a + b, 0);
}

export const STICKERS = [
  { id: "cat", title: "Kitty", img: IMG.cat, stars: 5 }, { id: "dog", title: "Puppy", img: IMG.dog, stars: 15 },
  { id: "duck", title: "Ducky", img: IMG.duck, stars: 30 }, { id: "pig", title: "Piggy", img: IMG.pig, stars: 50 },
  { id: "sheep", title: "Sheepy", img: IMG.sheep, stars: 75 }, { id: "lion", title: "Lion", img: IMG.lion, stars: 100 },
  { id: "penguin", title: "Penguin", img: "/images/animal_penguin.png", stars: 150 }, { id: "elephant", title: "Elephant", img: "/images/animal_elephant.png", stars: 200 },
  { id: "giraffe", title: "Giraffe", img: "/images/animal_giraffe.png", stars: 300 }, { id: "tiger", title: "Tiger", img: "/images/animal_tiger.png", stars: 400 },
];

export function evaluateBadges(state) {
  const earned = new Set(state.badges || []);
  const fresh = [];
  for (const b of BADGES) {
    if (!earned.has(b.id) && b.test(state)) { earned.add(b.id); fresh.push(b); }
  }
  return { badges: [...earned], fresh };
}
